module.exports = __webpack_public_path__ + "img/fridge.8b0b8fdd.png";